// @flow

// Constants
export const SET_CLIENT_INFO = "SET_CLIENT_INFO";
export const UPDATE_STEP = "UPDATE_STEP";
export const TOGGLE_INDICATOR = "TOGGLE_INDICATOR";
export const TOGGLE_RATING = "TOGGLE_RATING";
export const ADD_RATING = "ADD_RATING";
export const TOGGLE_CONTRIBUTING = "TOGGLE_CONTRIBUTING";
export const ADD_CONTRIBUTING = "ADD_CONTRIBUTING";
export const CALCULATE_RISK_SCORE = "CALCULATE_RISK_SCORE";
export const UPDATE_COMMENT = "UPDATE_COMMENT";
export const CLEAR_EVERYTHING = "CLEAR_EVERYTHING";

function clearEverything() {
  return {
    type: CLEAR_EVERYTHING
  };
}

// Toggle functions take index (for subsection), key
// Index is not needed for rating
function toggleIndicator(activeSubStep, behaviourKey) {
  return {
    type: TOGGLE_INDICATOR,
    index: activeSubStep,
    key: behaviourKey
  };
}

function toggleRating(measureKey) {
  return {
    type: TOGGLE_RATING,
    key: measureKey
  };
}

function toggleContributing(activeSubStep, contributingKey) {
  return {
    type: TOGGLE_CONTRIBUTING,
    index: activeSubStep,
    key: contributingKey
  };
}

function calculateRisk() {
  return {
    type: CALCULATE_RISK_SCORE
  };
}

function updateComment(value, section, activeSubStep) {
  return {
    type: UPDATE_COMMENT,
    section: section,
    index: activeSubStep,
    value: value
  };
}

// Add functions take index (for subsection), key (should be new), value
// Index is not needed for rating
function addRating(contributingKey, value) {
  return {
    type: ADD_RATING,
    key: contributingKey,
    value: value
  };
}

function addContributing(activeSubStep, contributingKey, value) {
  return {
    type: ADD_CONTRIBUTING,
    index: activeSubStep,
    key: contributingKey,
    value: value
  };
}

function setClientInfo(args) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_CLIENT_INFO,
      ...args
    });

    const { id, name, careType } = getState();

    return new Promise((resolve, reject) =>
      resolve({
        id,
        name,
        careType
      })
    );
  };
}

function updateStep(args) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_STEP,
      ...args
    });
  };
}

export {
  setClientInfo,
  updateStep,
  toggleIndicator,
  toggleRating,
  addRating,
  toggleContributing,
  addContributing,
  calculateRisk,
  updateComment,
  clearEverything
};



// WEBPACK FOOTER //
// ./src/actions/index.js